import { render, staticRenderFns } from "./ReservationSticker.vue?vue&type=template&id=7faddbe6&scoped=true"
import script from "./ReservationSticker.vue?vue&type=script&lang=js"
export * from "./ReservationSticker.vue?vue&type=script&lang=js"
import style0 from "./ReservationSticker.vue?vue&type=style&index=0&id=7faddbe6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7faddbe6",
  null
  
)

export default component.exports